import ContactModel from 'Models/ContactModel';

const NotificationModel = {};

NotificationModel.CATEGORIES = {
  orderHistory: {
    id: 'order_events',
    title: 'Order',
    icon: '/images/icons/favorite.svg',
  },
  balance: {
    id: 'balance',
    title: 'Balance',
    icon: '/images/icons/money.svg',
  },
  newOrders: {
    id: 'new_orders',
    title: 'New orders',
    icon: '/images/icons/bell.svg',
  },
  profile: {
    id: 'profile_events',
    title: 'Profile updated',
    icon: '/images/icons/bell.svg',
  },
  chat_events: {
    id: 'chat_events',
    title: 'New messages',
    icon: '/images/icons/bell.svg',
  },
};

NotificationModel.CHANNELS = [
  {
    id: 'mail',
    title: 'Email',
  },
  {
    id: 'discord',
    title: ContactModel.Discord.title,
    contact_id: ContactModel.Discord.id,
  },
  {
    id: 'telegram',
    title: ContactModel.Telegram.title,
    contact_id: ContactModel.Telegram.id,
  },
];

NotificationModel.BOOSTER_EVENTS = {
  balanceFundsAvailable: {
    title: 'balance_funds_available',
  },
  balanceFundsCredited: {
    title: 'balance_funds_credited',
  },
  balanceFundsWithdrawn: {
    title: 'balance_funds_withdrawn',
  },
  orderApproachingDeadline: {
    title: 'order_approaching_deadline',
  },
  orderCanceled: {
    title: 'order_canceled',
  },
  orderProblem: {
    title: 'order_problem',
  },
  orderDone: {
    title: 'order_done',
  },
  orderExpiredDeadline: {
    title: 'order_expired_deadline',
  },
  orderOnAuction: {
    title: 'order_on_auction',
  },
  orderTransferredToStatusInProgress: {
    title: 'order_transferred_to_status_in_progress',
  },
  orderInWarranty: {
    title: 'order_in_warranty',
  },
  profileApproved: {
    title: 'profile_approved',
  },
  profileBlocked: {
    title: 'profile_blocked',
  },
  profileRevision: {
    title: 'profile_on_revision',
  },
  profileDeclined: {
    title: 'profile_declined',
  },
  orderChanged: {
    title: 'order_changed',
  },
  orderWasReturned: {
    title: 'order_was_returned',
  },
  payoutApproved: {
    title: 'payout_approved',
  },
  payoutCanceled: {
    title: 'payout_canceled',
  },
  payoutDeclined: {
    title: 'payout_declined',
  },
  payoutError: {
    title: 'payout_error',
  },
  balanceChanged: {
    title: 'balance_changed',
  },
  // Deprecated @SKY-2306
  // waitForExecutor: {
  //   title: 'order_transferred_to_status_waiting_for_executor',
  // },
  executorWasChanged: {
    title: 'order_executor_was_changed',
  },
  executionRequestApproved: {
    title: 'execution_request_approved',
  },
  executionRequestRejected: {
    title: 'execution_request_rejected',
  },
  executionRequestOrderLimit: {
    title: 'execution_request_order_limit',
  },
  orderUpdated: {
    title: 'order_updated',
  },
};

NotificationModel.ADMIN_EVENTS = {
  executionRequestCreated: {
    title: 'execution_request_created',
  },
  executionRequestCanceled: {
    title: 'execution_request_canceled',
  },
};

NotificationModel.CLIENT_EVENTS = {
  orderStatusChanged: {
    title: 'order_status_changed',
  },
  chatDisabledByAdmin: {
    title: 'chat_disabled_by_admin_changed',
  },
  orderProOnAccount: {
    title: 'pro_on_account_status_changed',
  },
  orderDeadLineSet: {
    title: 'must_be_completed_at_changed',
  },
};

NotificationModel.BOOSTER_EVENTS_LIST = [
  NotificationModel.BOOSTER_EVENTS.balanceFundsAvailable,
  NotificationModel.BOOSTER_EVENTS.balanceFundsCredited,
  NotificationModel.BOOSTER_EVENTS.balanceFundsWithdrawn,
  NotificationModel.BOOSTER_EVENTS.orderApproachingDeadline,
  NotificationModel.BOOSTER_EVENTS.orderCanceled,
  NotificationModel.BOOSTER_EVENTS.orderProblem,
  NotificationModel.BOOSTER_EVENTS.orderDone,
  NotificationModel.BOOSTER_EVENTS.orderExpiredDeadline,
  NotificationModel.BOOSTER_EVENTS.orderOnAuction,
  NotificationModel.BOOSTER_EVENTS.orderTransferredToStatusInProgress,
  NotificationModel.BOOSTER_EVENTS.orderInWarranty,
  NotificationModel.BOOSTER_EVENTS.profileApproved,
  NotificationModel.BOOSTER_EVENTS.profileBlocked,
  NotificationModel.BOOSTER_EVENTS.profileRevision,
  NotificationModel.BOOSTER_EVENTS.profileDeclined,
  NotificationModel.BOOSTER_EVENTS.orderChanged,
  NotificationModel.BOOSTER_EVENTS.orderWasReturned,
  NotificationModel.BOOSTER_EVENTS.payoutApproved,
  NotificationModel.BOOSTER_EVENTS.payoutCanceled,
  NotificationModel.BOOSTER_EVENTS.payoutDeclined,
  NotificationModel.BOOSTER_EVENTS.payoutError,
  NotificationModel.BOOSTER_EVENTS.balanceChanged,
  // Deprecated @SKY-2306
  // NotificationModel.BOOSTER_EVENTS.waitForExecutor,
  NotificationModel.BOOSTER_EVENTS.executorWasChanged,
  NotificationModel.BOOSTER_EVENTS.executionRequestApproved,
  NotificationModel.BOOSTER_EVENTS.executionRequestRejected,
  NotificationModel.BOOSTER_EVENTS.executionRequestOrderLimit,
  NotificationModel.BOOSTER_EVENTS.orderUpdated,
];

NotificationModel.ADMIN_EVENTS_LIST = [
  NotificationModel.ADMIN_EVENTS.executionRequestCreated,
  NotificationModel.ADMIN_EVENTS.executionRequestCanceled,
];

NotificationModel.CLIENT_EVENTS_LIST = [
  NotificationModel.CLIENT_EVENTS.orderStatusChanged,
  NotificationModel.CLIENT_EVENTS.chatDisabledByAdmin,
  NotificationModel.CLIENT_EVENTS.orderProOnAccount,
  NotificationModel.CLIENT_EVENTS.orderDeadLineSet,
];

NotificationModel.CATEGORY_BY_ID = {
  [NotificationModel.CATEGORIES.orderHistory.id]: NotificationModel.CATEGORIES.orderHistory,
  [NotificationModel.CATEGORIES.balance.id]: NotificationModel.CATEGORIES.balance,
  [NotificationModel.CATEGORIES.newOrders.id]: NotificationModel.CATEGORIES.newOrders,
  [NotificationModel.CATEGORIES.profile.id]: NotificationModel.CATEGORIES.profile,
};

export default NotificationModel;
